import { ButtonProps, Pagination } from '@mui/material';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import { sxPagination, sxPaginationContrast } from './sxProps';

interface Props {
	currentPage: number;
	totalPages: number;
	handlePageChange: (newPage: number) => void;
}

const DefaultPagination: React.FC<Props> = ({ currentPage, totalPages, handlePageChange }) => {

	const accessibility = useAccessibility();

  return (
		<Pagination
			count={totalPages}
			sx={accessibility.contrastMode ? sxPaginationContrast : sxPagination} 
			hideNextButton hidePrevButton
			color='primary'
			page={currentPage}
			onChange={(_, newPageNumber) => { handlePageChange(newPageNumber) }}
/>
  )
}

export default DefaultPagination;